class OfferCodeButton extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['codeCopyButton']
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.copyToClipboard = this.copyToClipboard.bind(this)

    this.listeners.add(
      this.els.codeCopyButton.element,
      'click',
      this.copyToClipboard,
    )
  }

  copyToClipboard () {
    const offerCode = this.els.codeCopyButton.element.dataset.code
    const buttonText = window.theme.strings.copyCode
    const copySuccessMessage = window.theme.strings.copyCodeSuccess

    navigator.clipboard.writeText(offerCode)

    if (navigator.clipboard.writeText(offerCode)) {
      this.els.buttonText.element.textContent = copySuccessMessage

      setTimeout(() => {
        this.els.buttonText.element.textContent = buttonText
      }, 2000)
    } else {
      console.error('Failed to copy code to clipboard')
    }
  }
}

if (!customElements.get('offer-code-button')) {
  customElements.define('offer-code-button', OfferCodeButton)
}
